import {Suspense, type ReactNode} from 'react';
import {useQuotingAvailability} from '@/matic/features/quoting/hooks/useQuotingAvailability';
import {QuotingUnavailable} from '@/matic/features/quoting/components/generic/QuotingUnavailable';

type Props = {
  /** Today's element for the route, rendered unchanged when the tenant uses the AES desk. */
  readonly aesDesk: ReactNode;
  /** The generic workspace's page, when the route has one; otherwise the not-available state. */
  readonly generic?: ReactNode;
};

/** Calm while the gate resolves: the page's own backplate, no spinner, no flash. */
const pending = <div className="h-full bg-neutral-50" />;

/**
 * The runtime gate on `/quotes/*`: which workspace — if any — renders this route for the
 * signed-in tenant (`GET /quoting/capabilities`). On the AES quotes-first build the
 * answer is static, so `aesDesk` renders straight away exactly as it always has.
 */
export function QuotingRoute({aesDesk, generic}: Props) {
  const {loading, workspace} = useQuotingAvailability();
  if (loading) return pending;
  if (workspace === 'aes-desk') return <>{aesDesk}</>;
  if (workspace === 'generic' && generic)
    return <Suspense fallback={pending}>{generic}</Suspense>;
  return <QuotingUnavailable />;
}
